import React from "react";
import { Sparkles, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PlaceholderPanel({ title, description, icon: Icon, features = [], onBack }) {
  return (
    <div className="space-y-6" data-testid={`placeholder-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] font-medium mb-1" style={{ color: "#7A5E12" }}>
            Coming Soon
          </div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold" style={{ color: "#0B2545" }}>
            {title}
          </h1>
          <p className="mt-1 text-sm max-w-xl" style={{ color: "#64748B" }}>
            {description}
          </p>
        </div>
        {onBack && (
          <Button
            variant="outline"
            size="sm"
            onClick={onBack}
            className="h-9 px-3"
            style={{ borderColor: "#E2E8F0", color: "#0B2545" }}
            data-testid="placeholder-back"
          >
            <ArrowLeft className="h-3.5 w-3.5 mr-1.5" />
            Back to dashboard
          </Button>
        )}
      </div>

      <div
        className="rounded-2xl border-2 border-dashed p-10 sm:p-14 text-center"
        style={{ borderColor: "#E2E8F0", background: "#F8FAFC" }}
      >
        <span
          className="inline-grid place-items-center h-16 w-16 rounded-2xl mb-5"
          style={{ background: "rgba(212,175,55,0.18)", color: "#7A5E12" }}
        >
          {Icon ? <Icon className="h-7 w-7" /> : <Sparkles className="h-7 w-7" />}
        </span>
        <h2 className="font-display text-xl font-semibold mb-2" style={{ color: "#0B2545" }}>
          We're building this module next
        </h2>
        <p className="text-sm max-w-md mx-auto mb-6" style={{ color: "#64748B" }}>
          This area is reserved for the {title} module. Below is a preview of the
          capabilities planned for an upcoming release.
        </p>

        {features.length > 0 && (
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 max-w-2xl mx-auto text-left">
            {features.map((f) => (
              <li
                key={f}
                className="flex items-start gap-2.5 rounded-lg border bg-white px-3.5 py-2.5 text-sm"
                style={{ borderColor: "#E2E8F0", color: "#0B2545" }}
              >
                <span className="mt-1 h-1.5 w-1.5 rounded-full shrink-0" style={{ background: "#D4AF37" }} />
                <span>{f}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
